<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eV8wT5/tc-custom/9781426879708.jpg?1743862900802" alt="This image is the cover for the book Mountain Midwife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mountain Midwife
      </h1>
      <p class="bookDescription body article font2">
        <p>Kidnapped, blindfolded and driven to a desolate Rocky Mountain lodgefor midwife Rachel Devon it's the most terrifying birth she has ever attended to. But now that the baby's mother is dead, it's up to Rachel to get the child to safety. Much to Rachel's surprise, one of the kidnappers helps her escape. Cole McClure claims to be an undercover FBI agent, though Rachel doesn't trust him for a minute. He's got that sexy bad-boy edge, the type Rachel's been burned by way too often. But Cole comes through and with a blizzard bearing down on them, with killers and cops hot on their trail, they team up to find this innocent baby a home. And try to resist temptation when they're "forced" to share a bed through the cold winter nights.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassie Miles
      </h2>
      
      <p class="authorDescription body article">USA TODAY bestselling author Cassie Miles lives in Colorado. After raising two daughters and cooking tons of macaroni and cheese for her family, Cassie is trying to be more adventurous in her culinary efforts. She's discovered that almost anything tastes better with wine. When she's not plotting Harlequin Intrigue books, Cassie likes to hang out at the Denver Botanical Gardens near her high-rise home.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21c55b97